import { createSelector } from 'reselect';

const substate = (state) => state.storefront;

export const selectStorefrontConfiguration = () => createSelector(substate, (contextState) => contextState.storefront);
